// extracted by mini-css-extract-plugin
export default {"detail":"Collapse_detail__uSggG","key":"Collapse_key__YUJ8l","value":"Collapse_value__KYSv2"};